export default "__VITE_ASSET__af8d5c03__"